import TooltipPro from 'epn-ui/umd/dist/components/TooltipPro';
import BaseCopyableText from '@components/base/BaseCopyableText';
import useI18n from '@i18n';

export interface IOfferInfoProps {
    ordClientFullName: string;
    ordClientInn: string;
}

const OrdInfo: React.FC<IOfferInfoProps> = ({ ordClientFullName, ordClientInn }) => {
    const { t } = useI18n('Offers');

    return (
        ordClientFullName &&
        ordClientInn && (
            <TooltipPro title={t('Copy')}>
                <div>
                    <BaseCopyableText
                        copyableText={`${ordClientFullName} ИНН ${ordClientInn}`}
                        className="justify-between rounded-[6px] max-w-max !text-blueGray-300 hover:!text-blueGray-500 py-[6px] px-[8px] bg-opacity-50 lg:bg-opacity-0 bg-blueGray-100 hover:bg-blueGray-100"
                        textClassName="max-w-[calc(100vw-86px)] lg:max-w-[215px] xl:max-w-[292px]"
                    >
                        <div className="font-normal text-[12px] text-ellipsis">
                            <span className="break-all">{ordClientFullName}</span> ИНН&nbsp;
                            {ordClientInn}
                        </div>
                    </BaseCopyableText>
                </div>
            </TooltipPro>
        )
    );
};

export default OrdInfo;
